export class AysClinicPerformance {

  public static fromObj(obj: any): AysClinicPerformance {
    return new AysClinicPerformance(obj.cmi, obj.casemix);
  }

  constructor(
    public cmi: {[year: number]: number},
    public casemix: {[year: number]: number}
  ) {

  }
}
